<template>
  <v-app style="background-color: #f8f9fb">
    <v-container>
      <v-col cols="12">
        <v-card elevation="0" class="px-5 py-3">
          <div class="d-flex align-center mb-2">
            <v-card-title class="px-0 py-0">Consultar Cartões TEM</v-card-title>
            <v-tooltip bottom max-width="320">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  class="ml-1"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="dialogInfo = true"
                >
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <span>Clique para saber como funciona a consulta</span>
            </v-tooltip>
          </div>

          <v-row align="end">
            <v-col cols="12" sm="6" md="3">
              <span>Data Inicial</span>
              <v-text-field
                v-model="dataInicial"
                type="date"
                dense
                solo-inverted
                :disabled="loadConsulta"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <span>Data Final</span>
              <v-text-field
                v-model="dataFinal"
                type="date"
                dense
                solo-inverted
                :disabled="loadConsulta"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="2">
              <span>&nbsp;</span>
              <v-btn
                color="#4682B4"
                block
                height="40"
                style="font-size: 14px; font-weight: bold"
                :loading="loadConsulta"
                @click="consultaTem"
              >
                Consultar
                <v-icon right dark>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div class="caption grey--text mt-1">
            Período máximo: 1 mês
          </div>
        </v-card>
      </v-col>
    </v-container>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-alert v-if="mensagem" type="error" dense class="mb-4">
        {{ mensagem }}
      </v-alert>

      <v-card v-if="cartoes.length" elevation="0" class="pa-3">
        <v-data-table :headers="headers" :items="cartoes" class="elevation-0">
          <template v-slot:item.status="{ item }">
            <span v-if="item.status === 'Carregando...'" class="d-inline-flex align-center">
              <v-progress-circular
                :size="16"
                :width="2"
                indeterminate
                color="blue"
                class="mr-2"
              ></v-progress-circular>
              Carregando...
            </span>
            <span v-else>{{ item.status || "SEM STATUS" }}</span>
          </template>

          <template v-slot:item.acao="{ item }">
            <v-progress-circular
              v-if="item.status === 'Carregando...'"
              :size="24"
              :width="2"
              indeterminate
              color="blue"
            ></v-progress-circular>

            <template v-else>
              <v-btn
                v-if="item.status === 'SUSPENSO'"
                small
                color="green"
                :loading="loadAcao"
                @click="ativarCartao(item)"
              >
                Ativar
              </v-btn>
              <v-btn
                v-if="item.status === 'ATIVO' || item.status === 'SUSPENSO'"
                small
                color="red"
                class="ml-1"
                :loading="loadAcao"
                @click="cancelarCartao(item)"
              >
                Cancelar
              </v-btn>
              <v-btn
                v-if="item.status === 'ATIVO'"
                small
                color="orange"
                class="ml-1"
                :loading="loadAcao"
                @click="suspenderCartao(item)"
              >
                Suspender
              </v-btn>
              <v-btn
                v-if="item.status === 'PENDENTE'"
                small
                color="orange"
                :loading="loadAcao"
                @click="adesaoCartao(item)"
              >
                Adesão
              </v-btn>
              <span
                v-if="!temAcao(item.status)"
                class="caption grey--text"
              >
                —
              </span>
            </template>
          </template>
        </v-data-table>
      </v-card>
    </v-container>

    <v-dialog v-model="dialogInfo" max-width="520">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="primary" class="mr-2">mdi-information</v-icon>
          Como funciona a consulta
        </v-card-title>
        <v-card-text>
          Consulta de clientes na base do iVertex por data de contrato e status
          da situação na TEM Saúde.
          <br /><br />
          O período entre data inicial e data final não pode ultrapassar
          <strong>1 mês</strong>.
          <br /><br />
          Após listar os contratos, o sistema consulta o status atual de cada
          cartão na TEM Saúde para exibir as ações disponíveis (ativar,
          suspender, cancelar ou adesão).
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogInfo = false">Entendi</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import TemSaude from "@/services/temsaude";

export default {
  name: "TemSaudeLote",
  data: () => ({
    dataInicial: "",
    dataFinal: "",
    mensagem: "",
    loadConsulta: false,
    loadAcao: false,
    dialogInfo: false,
    cartoes: [],
    headers: [
      { text: "Cartão", value: "cartao" },
      { text: "Contrato", value: "contrato" },
      { text: "CPF", value: "cpf" },
      { text: "Nome", value: "nome" },
      { text: "Status", value: "status" },
      { text: "Ações", value: "acao", sortable: false },
    ],
  }),
  mounted() {
    const today = new Date().toISOString().split("T")[0];
    this.dataInicial = today;
    this.dataFinal = today;
  },
  methods: {
    cartaoLimpo(cartao) {
      return (cartao || "").replace(/ /g, "");
    },
    temAcao(status) {
      return ["ATIVO", "SUSPENSO", "PENDENTE"].includes(status);
    },
    normalizarStatus(statusRecebido) {
      if (statusRecebido === undefined || statusRecebido === null) {
        return "SEM STATUS";
      }
      const status = String(statusRecebido).trim();
      return status || "SEM STATUS";
    },
    aplicarStatus(cartao, statusRecebido) {
      this.$set(cartao, "status", this.normalizarStatus(statusRecebido));
    },
    periodoValido() {
      if (!this.dataInicial || !this.dataFinal) {
        this.mensagem = "Por favor, preencha ambas as datas.";
        return false;
      }

      const dataInicial = new Date(`${this.dataInicial}T00:00:00`);
      const dataFinal = new Date(`${this.dataFinal}T00:00:00`);

      if (Number.isNaN(dataInicial.getTime()) || Number.isNaN(dataFinal.getTime())) {
        this.mensagem = "Datas inválidas.";
        return false;
      }

      if (dataFinal < dataInicial) {
        this.mensagem = "A data final deve ser maior ou igual à data inicial.";
        return false;
      }

      const limite = new Date(dataInicial);
      limite.setMonth(limite.getMonth() + 1);

      if (dataFinal > limite) {
        this.mensagem = "O intervalo máximo permitido é de 1 mês.";
        return false;
      }

      return true;
    },
    async consultaTem() {
      this.mensagem = "";
      if (!this.periodoValido()) {
        return;
      }

      this.loadConsulta = true;
      try {
        const response = await TemSaude.consultaLoteLoja(
          this.dataInicial,
          this.dataFinal
        );
        this.cartoes = (response.data || []).map((item) => ({
          ...item,
          status: "Carregando...",
        }));
        await this.atualizarStatusCartoes();
      } catch (e) {
        this.mensagem =
          e?.response?.data?.mensagem || "Erro ao consultar os cartões.";
        this.cartoes = [];
      } finally {
        this.loadConsulta = false;
      }
    },
    async atualizarStatusCartoes() {
      for (const cartao of this.cartoes) {
        try {
          const response = await TemSaude.consultaCartaoStatus(
            cartao.cpf,
            this.cartaoLimpo(cartao.cartao)
          );
          // statusCartao pode vir "" — não manter "Carregando..."
          this.aplicarStatus(cartao, response.data?.statusCartao);
        } catch (e) {
          console.error(`Erro ao atualizar status do cartão ${cartao.cartao}`, e);
          this.aplicarStatus(cartao, "ERRO NA CONSULTA");
        }
      }
    },
    async ativarCartao(cartao) {
      if (!confirm(`Você tem certeza que deseja ativar o cartão ${cartao.cartao}?`))
        return;
      this.loadAcao = true;
      try {
        const response = await TemSaude.ativarCartao(
          cartao.cpf,
          this.cartaoLimpo(cartao.cartao)
        );
        this.aplicarStatus(cartao, response.data?.statusCartao);
      } catch (e) {
        alert("Erro ao ativar o cartão.");
      } finally {
        this.loadAcao = false;
      }
    },
    async cancelarCartao(cartao) {
      if (!confirm(`Você tem certeza que deseja cancelar o cartão ${cartao.cartao}?`))
        return;
      this.loadAcao = true;
      try {
        const response = await TemSaude.cancelarCartao(
          cartao.cpf,
          this.cartaoLimpo(cartao.cartao)
        );
        this.aplicarStatus(cartao, response.data?.statusCartao);
      } catch (e) {
        alert("Erro ao cancelar o cartão.");
      } finally {
        this.loadAcao = false;
      }
    },
    async suspenderCartao(cartao) {
      if (
        !confirm(`Você tem certeza que deseja suspender o cartão ${cartao.cartao}?`)
      )
        return;
      this.loadAcao = true;
      try {
        const response = await TemSaude.suspenderCartao(
          cartao.cpf,
          this.cartaoLimpo(cartao.cartao)
        );
        this.aplicarStatus(cartao, response.data?.statusCartao);
      } catch (e) {
        alert("Erro ao suspender o cartão.");
      } finally {
        this.loadAcao = false;
      }
    },
    async adesaoCartao(cartao) {
      this.loadAcao = true;
      this.mensagem = "";
      try {
        const response = await TemSaude.adesaoCartao(
          cartao.cpf,
          this.cartaoLimpo(cartao.cartao)
        );
        this.aplicarStatus(cartao, response.data?.statusCartao);
      } catch (e) {
        this.mensagem = "Erro ao fazer adesão do cartão.";
      } finally {
        this.loadAcao = false;
      }
    },
  },
};
</script>
